import { room } from "../../../libs/roomnew";
import kinoTooltip from "../../../room/kinoTooltip";
import { MEDIA_TYPE } from "../tracks/constants";
import { getLocalTrack } from "../tracks/functions";
import { LoadMonitor } from "./LoadMonitor";
import { showPerformanceOptimizerModal } from "./actions";
import { PERFORMANCE_FRAME_RATE, PERFORMANCE_ICON } from "./constants";

const PERFORMANCE_STATE={
    setting:3,//1 low, 2 medium,3 high
    frameHeight:720,
    maxFrameRate:PERFORMANCE_FRAME_RATE.high,
    remember:false,
    lastChangedByUser:false
};
let CPU_LOAD=[];
let CPU_LOAD_INTERVAL=0;
let tooltipInstance;
const CPU_WARNING_THRESHOLD=60;
export const getPerformanceState=()=>{
    return {...PERFORMANCE_STATE};
}
export const updatePerformanceSettingState=(setting,remember,changedByUser=false)=>{
    const frameHeight=setting <= 2 ? setting * 180 : 720;
    const maxFramerate=setting == 3 ? PERFORMANCE_FRAME_RATE.high : setting == 2 ? PERFORMANCE_FRAME_RATE.balanced : PERFORMANCE_FRAME_RATE.low;
    console.log("Saving performance setting framerate ", maxFramerate)
    PERFORMANCE_STATE.setting=setting;
    PERFORMANCE_STATE.frameHeight=frameHeight;
    PERFORMANCE_STATE.maxFrameRate=maxFramerate;
    PERFORMANCE_STATE.remember=remember;
    PERFORMANCE_STATE.lastChangedByUser=setting <=2 ? changedByUser : false;
}

export const storePerformanceSetting=(value)=>{
    localStorage.setItem("@performance-setting",''+Math.max(value,1));
}

export const getPerformanceSetting=()=>{
    const defaultSetting=3;
    let value=localStorage.getItem("@performance-setting");
    if(value){
        return parseInt(value,10)
    }else{
        return defaultSetting
    }
}

export const onCpuStatsUpdated=(avg)=>{
    console.log("Collected cpu usage",avg)
    const {setting} = getPerformanceState();
    if(avg >= CPU_WARNING_THRESHOLD && !getDontShowCpuWarning() && setting > 1){
        showHighCpuUsageWarning();
    }
}

const setDontShowCpuWarning=()=>{
    localStorage.setItem("@performance-warning",'dont_show');
}
const getDontShowCpuWarning=()=>{
    return localStorage.getItem("@performance-warning");
}

export const showHighCpuUsageWarning=()=>{
    const message=$("<p/>",{
        class:'text-left p-dynamic-text',
        html:`Your device is under strain, affecting its speed. Open Performance Optimizer and adjust the setting to enhance performance.`
    })
    const checkbox=$('<input/>',{
        type:'checkbox',
        id:"cpu_usage_warning_dont_show"
    }).on('change',()=>{
        if(checkbox.is(":checked")){
            setDontShowCpuWarning('dont_show');
        }else{
            setDontShowCpuWarning('');
        }
    })
    const dontShowAgain=$('<label/>',{
        class:'p-dynamic-text',
        html:[checkbox,` Don't show this again`]
    });
    const performanceOptimizerBtn=$("<button/>",{
        class: 'btn btn-primary kino-btn-primary btn-sm',
        html:'Performance Optimizer',
        'data-dismiss':'alert',
        'aria-label':'close',
    }).on('click',()=>{
        showPerformanceOptimizerModal();
    })
    const btnCancel=$("<button/>",{
        class:'btn kino-btn-secondary btn-sm',
        'data-dismiss':'alert',
        'aria-label':'close',
        html:'CANCEL'
    })
    const bottomAction=$("<div/>",{
        class:'d-flex justify-content-end align-items-center w-100',
        html: [btnCancel,performanceOptimizerBtn]
    })
    const title = $('<h5/>',{
        class:'text-kino-red text-center',
        html:`<i class="fa fa-exclamation-triangle"></i> Computer under strain`
    })
    const notificationBody=$("<div/>",{
        class:'d-flex flex-column',
        html:[
            title,
            message,
            dontShowAgain,
            bottomAction
        ]
    })
    $.showNotification({
        body: notificationBody,
        type: "white",
        duration: 60000
    });
}

export const stopCpuStatsCollection=()=>{
    CPU_LOAD=[];
    clearInterval(CPU_LOAD_INTERVAL);

}
export const startCollectingCpuLoad=(minutes=5)=>{
    CPU_LOAD=[];
    let minutesLeft=minutes;
    clearInterval(CPU_LOAD_INTERVAL);
    CPU_LOAD_INTERVAL=setInterval(()=>{
        const usagePercent=getCpuUsageAvg(1);
        console.log("Cpu usage collector collected ",usagePercent)
        CPU_LOAD.push(usagePercent);
        minutesLeft--;
        if(minutesLeft <= 0){
            clearInterval(CPU_LOAD_INTERVAL)
            onCpuStatsUpdated(getCollectedCpuAvg())
        }
    },60000)
}

export const getCollectedCpuAvg=()=>{
    let total = 0;
    CPU_LOAD.forEach(load=>{
        total+=load;
    })
    return total / CPU_LOAD.length;
}

export const getCpuUsageAvg=(minutes)=>{
    return api.global.sendSync('performance:cpu_avg',minutes);
}

const getOutboundRtpFramerate=async ()=>{
    const stats = await getRTCStats();
    // console.log("RTC Stats",stats)
    const mediaSourceStats = stats.find(stat=>stat.type === "outbound-rtp" && stat.kind === "video" && stat.contentType !=='screenshare');
    // console.log("Outbound rtp stats",mediaSourceStats)
    return mediaSourceStats?.framesPerSecond;
}

const getMediaSourceFramerate=async ()=>{
    const localVideo = getLocalTrack(MEDIA_TYPE.VIDEO);
    const trackId = localVideo?.kinoTrack?.track?.id;
    // "78ad01dc-bf25-4cd7-a5d7-dae092324863"
    const stats = await getRTCStats();
    const mediaSourceStats = stats.find(stat=>stat.type === "media-source" && stat.trackIdentifier === trackId);
    // console.log("Media source stats",mediaSourceStats)
    return mediaSourceStats?.framesPerSecond;
}

const getRTCStats=async ()=>{
    if(!room || !room.getActivePeerConnection()){
        return [];
    }
    const stats = await room.getActivePeerConnection().getStats();
    // console.log("RTC Stats",Array.from(stats.values()))
    return Array.from(stats.values());
}

export const getSenderFrameRate=async ()=>{
    const outboundRtpFramerate = await getOutboundRtpFramerate();
    const mediaSourceFramerate = await getMediaSourceFramerate();
    console.log("---------------------------------------------------------")
    console.log("Framerate from outboundRtpFramerate", outboundRtpFramerate)
    console.log("Framerate from mediaSourceFramerate", mediaSourceFramerate)
    return outboundRtpFramerate;
}

export const monitorFrameRate=()=>{
    const monitor = new LoadMonitor();
    monitor.startMonitor();
    // showPerformanceOptimizerSettingsChangedTooltip("TEST");
}

export const showPerformanceOptimizerSettingsChangedTooltip=(setting)=>{
    console.log("Showing performance optimizer tooltip",setting)
    hidePerformanceOptimizerSettingChangedTooltip();
    const TooltipTitle=$("<div/>",{
        class:"d-flex justify-content-center align-items-center tooltip-title",
        html:[PERFORMANCE_ICON,'<span class="font-weight-bold mt-1">Performance Optimizer</span>'],
    })

    const TooltipContent = $("<div/>",{
        class:"py-2 px-1 d-flex justify-content-center text-center",
        html:`<p class='mb-0 text-center'>Performance Optimizer set to <b>${setting}.</p>`
    })

    const message=$("<div/>",{
        class:"d-flex flex-column justify-content-center align-items-center",
        html:[TooltipTitle,TooltipContent]
    })

    tooltipInstance = new kinoTooltip('menu-tooltip-container',message,{
        left: '-132px',
        bottom: '120%',
        width:'325px',
        autohideSeconds:5,
        customClass:'align-center performance-optimizer-changed-tooltip'
    });

    tooltipInstance.addTooltip();

}

    const hidePerformanceOptimizerSettingChangedTooltip=()=>{
        $(".performance-optimizer-changed-tooltip").remove();
        if(tooltipInstance){
            tooltipInstance.destroy();
            tooltipInstance=undefined;
        }
    }
